export const ApproveTxConfirmation = "ERC20ApproveTxConfirmation" as const;
export const ApproveTxError = "ERC20ApproveTxError" as const;
export const ApproveTxHash = "ERC20ApproveTxHash" as const;
export const TxConfirmationEventName = "OxTxConfirmation" as const;
export const TxErrorEventName = "OxTxError" as const;
export const TxHashEventName = "OxTxHash" as const;
